import { fetchUsers } from './user'
import { fetchGroups } from './group'
import { fetchRoles } from './role'
import { fetchPermissions } from './permission'
import { AUTH_PROFILE_RECEIVE } from './authProfile'

export const INITIAL_DATA_REQUEST = 'loading/INITIAL_DATA_REQUEST'
export const INITIAL_DATA_RECEIVE = 'loading/INITIAL_DATA_RECEIVE'
export const INITIAL_DATA_FAILURE = 'loading/INITIAL_DATA_FAILURE'
export const DATA_LOAD_FAILURE = 'loading/DATA_LOAD_FAILURE'
export const LOADING_APP_DATA = 'loading/LOADING_APP_DATA'
export const RECEIVED_APP_CONTEXT = 'loading/RECEIVED_APP_CONTEXT'

const initialState = {
  isLoading: false,
  isLoadingDialog: false,
  isLoadingPartnerFilteredGroups: false,
  isFetch: false,
  hasLoadedAppData: false,
  hasReceivedAppContext: false,
}

export const reducer = (state = initialState, action) => {
  switch(true) {
    case /CONTEXT_REQUEST/.test(action.type):
      return { ...state, isLoading: true, hasReceivedAppContext: false }
    case /CONTEXT_RECEIVE/.test(action.type):
    case /CONTEXT_FAILURE/.test(action.type):
      return { ...state, isLoading: false, hasReceivedAppContext: true }
    case /DIALOG_REQUEST/.test(action.type):
      return { ...state, isLoadingDialog: true }
    case /DIALOG_RECEIVE/.test(action.type):
      return { ...state, isLoadingDialog: false }
    case /DIALOG_FAILURE/.test(action.type):
      return { ...state, isLoadingDialog: false }
    case /GROUP_FILTERED_PARTNERS_FAILURE/.test(action.type):
    case /GROUP_FILTERED_PARTNERS_RECEIVE/.test(action.type):
      return {...state, isLoadingPartnerFilteredGroups: false}
    case /GROUP_FILTERED_PARTNERS_REQUEST/.test(action.type):
      return {...state, isLoadingPartnerFilteredGroups: true}
    case AUTH_PROFILE_RECEIVE === action.type:
      // Prevents displaying empty page
      // Assumes Action type is only emitted on initial page load
      return { ...state, isLoading: true }
    case /LOADING_APP_DATA/.test(action.type):
      return { ...state, hasLoadedAppData: action.isDone }
    case /PROFILE_REQUEST/.test(action.type):
      return { ...state, isLoading: true }
    case /PROFILE_RECEIVE/.test(action.type):
    case /PROFILE_FAILURE/.test(action.type):
      return { ...state, isLoading: false }
    case RECEIVED_APP_CONTEXT === action.type:
      return { ...state, hasReceivedAppContext: action.hasReceived }
    case /INITIAL_DATA_REQUEST/.test(action.type):
      return { ...state, isLoading: true }
    case /INITIAL_DATA_RECEIVE/.test(action.type):
      return { ...state, isLoading: false }
    case /INITIAL_DATA_FAILURE/.test(action.type):
      return { ...state, isLoading: false }
    case /SINGLE_CLIENT_REQUEST/.test(action.type):
      return { ...state, isLoadingDialog: true, isFetch: true }
    case /SINGLE_CLIENT_RECEIVE/.test(action.type):
      return { ...state, isLoadingDialog: false, isFetch: false }
    case /SINGLE_CLIENT_FAILURE/.test(action.type):
      return { ...state, isLoadingDialog: false, isFetch: false }
    case /registration\/REGISTRATION_USER_REQUEST/.test(action.type):
      return { ...state, isLoading: true }
    case /registration\/REGISTRATION_USER_RECEIVE/.test(action.type):
      return { ...state, isLoading: false }
    case /registration\/REGISTRATION_USER_FAILURE/.test(action.type):
      return { ...state, isLoading: false }
    case /group\/GROUPS_REQUEST/.test(action.type):
    case /permission\/REQUEST/.test(action.type):
    case /roles\/REQUEST/.test(action.type):
    case /user\/USERS_REQUEST/.test(action.type):
      return { ...state, isLoading: true }
    case /group\/GROUPS_FAILURE/.test(action.type):
    case /group\/GROUPS_RECEIVE/.test(action.type):
    case /permission\/FAILURE/.test(action.type):
    case /permission\/RECEIVE/.test(action.type):
    case /roles\/FAILURE/.test(action.type):
    case /roles\/RECEIVE/.test(action.type):
    case /user\/USERS_FAILURE/.test(action.type):
    case /user\/USERS_RECEIVE/.test(action.type):
      if (action.meta.isRefreshRequired) {
        return { ...state, isLoading: false }
      }
      return state
    default:
      return state
  }
}

export function fetchInitialData() {
  return (dispatch, getState) => {
    dispatch({type: INITIAL_DATA_REQUEST})
    return Promise.all([
      dispatch(fetchUsers()),
      dispatch(fetchGroups()),
      dispatch(fetchRoles()),
      dispatch(fetchPermissions())
    ])
    .then(response => {
      let err = response.filter(data => {
        return data.error
      })
      if (err.length > 0) {
        dispatch({type: INITIAL_DATA_FAILURE})
        // TODO: Is DATA_LOAD_FAILURE being used for anything? Looks like initial data failure takes care of error handeling
        // and would break out of the async chain as long as we placed a return in front of it
        return dispatch({type: DATA_LOAD_FAILURE})
      }
      return dispatch({type: INITIAL_DATA_RECEIVE})
    })
  }
}

export const hasLoadedAppData = (isDone) => ({ type: LOADING_APP_DATA, isDone })
export const hasReceivedAppContext = (hasReceived) => ({ type: RECEIVED_APP_CONTEXT, hasReceived })

export default reducer
